import { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Language } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const languageOptions = [
  { code: 'en', labelKey: 'language.options.en' },
  { code: 'pt-BR', labelKey: 'language.options.ptBR' },
  { code: 'es', labelKey: 'language.options.es' },
];

const LanguageSwitcherButton = ({ sx, variant = 'text', size = 'small' }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { t, i18n } = useTranslation('common');

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
    handleClose();
  };

  return (
    <>
      <Button
        sx={sx}
        onClick={handleOpen}
        variant={variant}
        size={size}
        startIcon={<Language />}
      >
        {t('language.change')}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {languageOptions.map((option) => (
          <MenuItem
            key={option.code}
            selected={i18n.resolvedLanguage === option.code}
            onClick={() => { handleChangeLanguage(option.code); }}
          >
            {t(option.labelKey)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcherButton;
